import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedCopy } from '../intl/TranslatedCopy';

import { Button } from '../components';

const DownloadModalCancelOverlay = ({ cancelDownload }) => (
  <div className='flex-container center u-full-width u-full-height'>
    <Button extraClassName='ncss-btn-primary-dark' data-desc='downloadModal_cancelDownload' onClick={cancelDownload}>
      <TranslatedCopy id='downloads.cancel' />
    </Button>
  </div>
);

DownloadModalCancelOverlay.propTypes = {
  cancelDownload: PropTypes.func.isRequired
};

export default DownloadModalCancelOverlay;
